import * as React from 'react';
import {classes} from './ItemSubscription.st.css';
import {Text} from 'wix-ui-tpa/cssVars';

export interface SubscriptionProps {
  dataHook: string;
  subscription: {name: string; duration: string};
}

export enum SubscriptionDataHook {
  Name = 'SubscriptionDataHook.Name',
  Duration = 'SubscriptionDataHook.Duration',
}

export class ItemSubscription extends React.PureComponent<SubscriptionProps> {
  public render() {
    const {subscription, dataHook} = this.props;

    return (
      <div className={classes.root} data-hook={dataHook}>
        <Text data-hook={SubscriptionDataHook.Name} className={classes.text}>
          {subscription.name}
        </Text>
        <Text data-hook={SubscriptionDataHook.Duration} className={classes.text}>
          {subscription.duration}
        </Text>
      </div>
    );
  }
}
